export default __webpack_public_path__ + "static/image15-8b5e0a8bff22f2a1226bac630de20091.jpg";